"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventDispatcher_1 = require("./lib/gate/EventDispatcher");
var mobx_1 = require("mobx");
var Model = (function () {
    function Model(dataStore) {
        this.dataStore = dataStore;
        this.dispatcher = new EventDispatcher_1.EventDispatcher();
        this.validateFunctions = {};
        this.errors = {};
        this.loading = false;
    }
    Model.prototype.test = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log("PDF Model.test");
                return [2];
            });
        });
    };
    Model.prototype.addValidateFunction = function (key, f) {
        this.validateFunctions[key] = f;
    };
    Model.prototype.removeValidateFunction = function (key) {
        this.validateFunctions[key] = null;
    };
    Model.prototype.validateDefinedUserFields = function () {
        var _this = this;
        var _a = this, definedUserId = _a.definedUserId, task = _a.task;
        var result = true;
        var firstComponentWithError;
        task.form.users.forEach(function (user) {
            if (user.id === definedUserId) {
                var elements = document.getElementsByClassName("form-user-" + user.css);
                for (var i = 0; i < elements.length; i++) {
                    var element = elements[i];
                    if (element.id === undefined || element.id.trim().length === 0) {
                        continue;
                    }
                    var value = _this.json_data[element.id] || _this.json_data[element.name] || "";
                    if (element.className.indexOf("form-required") !== -1 &&
                        !(value instanceof Date) &&
                        (value === undefined || value.toString().trim().length === 0)) {
                        _this.errors[element.id] = "This field is required";
                        result = false;
                        if (firstComponentWithError === undefined) {
                            firstComponentWithError = element;
                        }
                    }
                }
            }
        });
        this.dispatcher.dispatch();
        if (firstComponentWithError) {
            firstComponentWithError.focus();
        }
        return result;
    };
    Model.prototype.validateFields = function () {
        var result = true;
        var firstComponentWithError;
        var elements = document.getElementsByClassName("form-required");
        for (var i = 0; i < elements.length; i++) {
            var element = elements[i];
            if (element.id === undefined || element.id.trim().length === 0) {
                continue;
            }
            var value = this.json_data[element.id] || this.json_data[element.name] || "";
            if (!(value instanceof Date) &&
                (value === undefined || value.toString().trim().length === 0)) {
                this.errors[element.id] = "This field is required";
                result = false;
                if (firstComponentWithError === undefined) {
                    firstComponentWithError = element;
                }
            }
        }
        this.dispatcher.dispatch();
        if (firstComponentWithError) {
            firstComponentWithError.focus();
        }
        return result;
    };
    Model.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var results, key, f, r;
            return __generator(this, function (_a) {
                results = [];
                this.errors = {};
                for (key in this.validateFunctions) {
                    f = this.validateFunctions[key];
                    if (!f) {
                        continue;
                    }
                    r = f();
                    results.push(r);
                }
                if (results.includes(false) || !this.validateDefinedUserFields()) {
                    return [2, false];
                }
                return [2, true];
            });
        });
    };
    Model.prototype.validateEditForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var results;
            return __generator(this, function (_a) {
                results = [];
                this.errors = {};
                if (!this.validateFields()) {
                    return [2, false];
                }
                return [2, true];
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], Model.prototype, "json_data", void 0);
    return Model;
}());
exports.Model = Model;
//# sourceMappingURL=data:application/json;base64,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